<div class="radio-field">
  <div class="ui form">
    @for (item of question?.questionDropdowns; track item) {
    <div class="container field">
      <label
        [ngClass]="{
          disabled: disabled || myFormControl.disabled || item.disabled
        }"
      >
        <input
          [formControl]="myFormControl"
          type="radio"
          name="{{ radioName }}-{{ question?.id }}"
          id="{{ 'question-input-' + question.id }}"
          class="{{ 'question-input-' + question.id }}"
          [attr.disabled]="
            disabled || myFormControl.disabled || item.disabled || null
          "
          [value]="item?.value"
          [attr.tabindex]="tabIndex"
        />
        <span class="checkmark"></span>
        <span class="lbl-text">{{ item?.display }}</span>
      </label>
    </div>
    }
  </div>

  @if (myFormControl?.errors) {
  <div class="clear validation-text">
    @if (myFormControl?.errors?.required) {
    <div>{{ question?.question }} {{ "is-required" | transloco }}</div>
    }
  </div>
  }
</div>
